import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=22885203&"
import script from "./AlertDetails.vue?vue&type=script&lang=ts&"
export * from "./AlertDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports